export default "__VITE_ASSET__0117d691__"